export default "__VITE_ASSET__CawBfDBI__"